import React from "react";
import { criterionLinkType } from "../../../../common/types/search/search";

export default function CriterionLink({ link }: { link: criterionLinkType }) {
	if (!link) {
		return null;
	}

	return (
		<a
			className="dropdown-link"
			href={link.url}
			onClick={(e) => e.stopPropagation()}
			target="_blank"
			rel="noreferrer"
		>
			{link.content}
		</a>
	);
}
